import {useRef} from "react"
import {debounce} from "../misc/utils"
import {filterVerlaufData} from "./versorgungsluecken-verlauf"

const CURRENT_YEAR = new Date().getFullYear()

const buildChartVerlauf = (verlaufData, theme) => ({
    bottomLabels: verlaufData?.map((item) => item?.jahr),
    datasets: [
        {
            label: "Monatliches Nettoeinkommen",
            data: verlaufData?.map(
                (item) => item?.nettoVersorgungAusEinkuenften,
            ),
            backgroundColor: theme?.VERSORGUNGSLUECKENVERLAUF?.einkuenfte,
        },
        {
            label: "Bestehende gesetzliche Versorgung",
            data: verlaufData?.map(
                (item) => item?.gesetzlicheVersorgungNettoEuro,
            ),
            backgroundColor: theme?.VERSORGUNGSLUECKENVERLAUF?.rente,
        },
        {
            label: "Summe sonstige Versorgung",
            data: verlaufData?.map(
                (item) =>
                    item?.summeNettorentenPrivateUndBetrieblicheBestehendeVersorgungEuro,
            ),
            backgroundColor: theme?.VERSORGUNGSLUECKENVERLAUF?.summe,
        },
        {
            label: "Versorgungslücke",
            data: verlaufData?.map((item) => item?.luecke),
            backgroundColor: theme?.VERSORGUNGSLUECKENVERLAUF?.luecke,
        },
    ],
})

const chartDiesesjahr = (ergebnisVersorgungssituationHibli, theme) => ({
    bottomLabels: [""],
    datasets: [
        {
            label: "bestehende Versorgung",
            data: [
                ergebnisVersorgungssituationHibli?.kapitalImTodesfallBestehend,
            ],
            backgroundColor: theme?.VERSORGUNGSLUECKENVERLAUF?.summe,
        },
        {
            label: "Versorgungslücke",
            data: [ergebnisVersorgungssituationHibli?.gesamtKapitalbedarfEuro],
            backgroundColor: theme?.VERSORGUNGSLUECKENVERLAUF?.luecke,
        },
    ],
})

const targetToPointerVerlauf = {
    kunde: "/hinterbliebenenstrecke/chartVerlaufKunde",
    ehepartner: "/hinterbliebenenstrecke/chartVerlaufPartner",
}

const targetToPointer = {
    kunde: "/hinterbliebenenstrecke/chartKunde",
    ehepartner: "/hinterbliebenenstrecke/chartPartner",
}

export const HinterbliebenenStreckeActions = ({
    updateData,
    sendDataToBackend,
    getDataFromPointer,
    theme,
}) => {
    const buildAndFilterVerlaufHibli = (verlauf, tableData, target) => {
        const von = getDataFromPointer("/appstate/zeitraum/von")
        const bis = getDataFromPointer("/appstate/zeitraum/bis")
        const filterArt = getDataFromPointer(`/appstate/zeitraumArt`)
        const filteredVerlauf = filterVerlaufData(
            verlauf?.[target]?.versorgungssituationList,
            von,
            bis,
            filterArt,
        )
        const chartVerlauf = buildChartVerlauf(filteredVerlauf, theme)
        const chart = chartDiesesjahr(tableData, theme)
        updateData(bis, "/hinterbliebenenstrecke/zeitraum/bis")
        updateData(chartVerlauf, targetToPointerVerlauf?.[target])
        updateData(chart, targetToPointer?.[target])
    }

    const reloadKunde = (target) => {
        const verlauf = getDataFromPointer("/ergebnisVerlaufHibli")
        buildAndFilterVerlaufHibli(verlauf, target)
    }

    const latestBuildRef = useRef()
    latestBuildRef.current = reloadKunde

    const debouncedSendDataRef = useRef()
    if (!debouncedSendDataRef.current) {
        debouncedSendDataRef.current = debounce(
            (...args) => latestBuildRef.current(...args),
            500,
        )
    }

    return {
        CALC_CONTEXTAREA_HINTERBLIEBENE: async (stagingArea) => {
            const {
                ergebnisVerlaufHibli: verlauf,
                ergebnisVersorgungssituationHibli: tableData,
            } = stagingArea?.calcData
                ? stagingArea.calcData
                : ((await sendDataToBackend(stagingArea?._links?.calculate))
                      ?._data ?? {})
            buildAndFilterVerlaufHibli(verlauf, tableData, "kunde")
            buildAndFilterVerlaufHibli(verlauf, tableData, "ehepartner")
            updateData(verlauf, "/ergebnisVerlaufHibli")
            updateData(tableData, "/ergebnisVersorgungssituationHibli")
        },
        HIBLI_INIT: () => {
            updateData(`Brutto ${CURRENT_YEAR}`, "/hinterbliebenenstrecke/bruttoLabel")
            updateData(`Netto ${CURRENT_YEAR}`, "/hinterbliebenenstrecke/nettoLabel")
        },
        REBUILD_HIBLI_VERLAUF: () => {
            const verlauf = getDataFromPointer("/ergebnisVerlaufHibli")
            const tableData = getDataFromPointer(
                "/ergebnisVersorgungssituationHibli",
            )
            buildAndFilterVerlaufHibli(verlauf, tableData, "kunde")
            buildAndFilterVerlaufHibli(verlauf, tableData, "ehepartner")
        },
    }
}
